// Re-export the programmatic API from the lean CLI package.
export * from '@json-to-office/jto-cli';
